import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(passwordField: string, confirmField: string): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
        const password = form.get(passwordField)?.value;
        const confirm = form.get(confirmField)?.value;

        if (!password || !confirm) {
            return null;
        }

        return password === confirm ? null : { passwordMismatch: true };
    };
}
